import collegeFinderImg from '../assets/project-images/college-finder.png';
import easyFixImg from '../assets/project-images/Product teardown-bro.svg';
import labDiagImg from '../assets/project-images/lab-diagnostics.svg';
import officeLeaveImg from '../assets/project-images/Quitting a job-rafiki.svg';
import ewalletImg from '../assets/project-images/ewallet.svg'
import documentConvImg from '../assets/project-images/document_conv.svg'

import {collegeFinderProject, docuConvertProject, eWalletProject, easyFixProject, labDiagnosticsProject, officeLeaveProject} from '../assets/js/project-items';

export default function ProjectSection() {

    const ProjectItem = (props)=>{
        const {project,image,bgColor} = props;
        let _className = `project-item shadow-sm ${bgColor}`;
        return (
            <div className={_className}>
                <div className="row flex-lg-row-reverse">
                    <div className="row flex-lg-row-reverse align-items-center g-5">
                        <div className="col-10 col-sm-8 col-lg-6">
                            <img src={image} className="d-block mx-lg-auto img-fluid"  width="500" height="500"  alt="hero_image"/>
                        </div>

                        <div className="col-lg-6">
                            <h3 className='project-title'>{project['title']}</h3>
                            <div className="project-description text-wrap mb-5">{project.desc}</div>
                            
                            <h5 className='project-type'>{project['type']}</h5>
                            
                            <ul className='project-tools'>
                            {
                                project.tools.map((item,index)=>(
                                    <li key={index}>{item}</li>
                                ))
                            }
                            </ul>

                            <a className='project-url align-items-center' href={project.url} rel="noreferrer" target={'_blank'}>
                                Visit {project.title}
                                <i className='pi pi-external-link ms-1'></i>
                            </a>
                        </div>
                       
                    </div>
                </div>
            </div>
        )
    }

    return(
        <section id="projects" className="section">
            <div className="container">
                <h2 className="text-center mb-3">Works & Projects</h2>

                <div className="row">
                    <div className="col-md mb-3">
                        <ProjectItem project={collegeFinderProject} image={collegeFinderImg} bgColor={'bg-light'}/>
                    </div>
                </div>

                <div className="row row-cols-lg-2">

                    <div className="col-md mb-3">
                        <ProjectItem project={docuConvertProject} image={documentConvImg} bgColor={'light-blue'}/>
                    </div>

                    <div className="col-md mb-3">
                        <ProjectItem project={eWalletProject} image={ewalletImg} bgColor={'light-green'}/>
                    </div>

                    <div className="col-md mb-3">
                        <ProjectItem project={officeLeaveProject} image={officeLeaveImg} bgColor={'light-green'}/>
                    </div>

                    <div className="col-md mb-3">
                        <ProjectItem project={easyFixProject} image={easyFixImg} bgColor={'light-yellow'}/>
                    </div>

                    <div className="col-md mb-3">
                        <ProjectItem project={labDiagnosticsProject} image={labDiagImg} bgColor={'bg-light'}/>
                    </div>

                    
                    
                </div>
            </div>
        </section>
    )
};
